import React from "react";
import { useNavigate } from "react-router-dom";
import AddCollection from "../components/collection/AddCollection";
import Title from "../components/header/Title";

const CreateCollection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Title
        title="Add New Collection"
        subtitle="Group existing products into a new collection"
        onBack={() => navigate("/collections")}
      />
      <AddCollection />
    </React.Fragment>
  );
};

export default CreateCollection;
